/**
 * A dispensa do aviso "Seus créditos estão acabando" (15/09/2026).
 *
 * O aviso de saldo BAIXO é uma faixa fechável: quem clica no "×" não quer
 * vê-la de novo a cada mensagem. A dispensa fica no `localStorage` com uma
 * DATA LIMITE (7 dias) — passado o prazo, o aviso volta sozinho. Só a faixa
 * de saldo baixo é dispensável: a de saldo ESGOTADO é bloqueio, não aviso, e
 * não tem "×".
 *
 * ★ [SHOULD-6, review do PR #2261] A chave é CARIMBADA POR ESCRITÓRIO — mesmo
 * padrão de `central-config/utils/guide-storage.js::guideStorageKey`. Saldo
 * de créditos é por escritório, e o time interno alterna escritórios no
 * mesmo navegador: uma chave global fazia a dispensa de UM escritório
 * silenciar o aviso de saldo baixo de outro, no mesmo navegador.
 * `idEscritorio` ausente cai em `'na'` — chave parcial é melhor que uma
 * chave global compartilhada por todo mundo.
 *
 * Puro: o relógio e o storage entram por parâmetro, para o teste não depender
 * da hora da máquina nem do jsdom. `try/catch` nos dois sentidos — modo
 * privado, storage cheio ou bloqueado NUNCA podem derrubar o composer; sem
 * storage, o aviso simplesmente volta no F5.
 */
const PREFIXO_CHAVE_DA_DISPENSA = 'iaCreditosAvisoSaldoBaixoDispensadoAte'
export const chaveDaDispensa = (idEscritorio) =>
  `${PREFIXO_CHAVE_DA_DISPENSA}_${idEscritorio || 'na'}`
export const DIAS_DE_DISPENSA = 7
const MS_POR_DIA = 24 * 60 * 60 * 1000

function storagePadrao() {
  try {
    return globalThis.localStorage || null
  } catch (e) {
    return null
  }
}

/** `true` enquanto a dispensa gravada ainda não venceu. */
export function avisoDeSaldoBaixoDispensado({
  agora = Date.now(),
  storage = storagePadrao(),
  idEscritorio,
} = {}) {
  if (!storage) return false
  try {
    const ate = Number(storage.getItem(chaveDaDispensa(idEscritorio)))
    return Number.isFinite(ate) && ate > agora
  } catch (e) {
    return false
  }
}

/** Grava a dispensa por `DIAS_DE_DISPENSA` a partir de `agora`; devolve o limite. */
export function dispensarAvisoDeSaldoBaixo({
  agora = Date.now(),
  storage = storagePadrao(),
  idEscritorio,
} = {}) {
  const ate = agora + DIAS_DE_DISPENSA * MS_POR_DIA
  if (!storage) return ate
  try {
    storage.setItem(chaveDaDispensa(idEscritorio), String(ate))
  } catch (e) {
    /* storage indisponível: a dispensa vale só nesta sessão */
  }
  return ate
}
